'use strict';

/**
 *
 * @name: UserRun
 *
 */

function ApiRun(
  APP_CONSTANTS,
  $rootScope
) {

  'ngInject';

  // $rootScope.apiUrlBak = $rootScope.apiUrlBak || APP_CONSTANTS.apiUrl;
  if(window.location.href.includes('local')){
    $rootScope.apiUrlNew = $rootScope.apiUrlLocal ||  APP_CONSTANTS.apiUrlLocal;
    // $rootScope.apiUrlNew = $rootScope.apiUrlDev ||  APP_CONSTANTS.apiUrlDev;
  }else if(window.location.href.includes('frontend-prod.yund.co')){
    $rootScope.apiUrlNew = $rootScope.apiUrlYund ||  APP_CONSTANTS.apiUrlYund;
  }else if(window.location.href.includes('nn-www.yund.co')){
    $rootScope.apiUrlNew = $rootScope.apiUrlNnYund ||  APP_CONSTANTS.apiUrlNnYund;
  }else if(window.location.href.includes('yund.co')){
    $rootScope.apiUrlNew = $rootScope.apiUrlDev ||  APP_CONSTANTS.apiUrlDev;
  }else if(window.location.href.includes('nowness.cn')){
    $rootScope.apiUrlNew = $rootScope.apiUrlNowness ||  APP_CONSTANTS.apiUrlNowness;
  }else{
    $rootScope.apiUrlNew = $rootScope.apiUrlProd ||  APP_CONSTANTS.apiUrlProd;

  }


}

export default ApiRun;



// WEBPACK FOOTER //
// ./app/components/_api/_api.run.js